import { useService } from 'react-reservice';

import { getUseServiceWithSubscriptionKeys } from '@webtrader/core/utils';

import symbolsService from './service';

export const useSymbols = () => {
  return useService(symbolsService, (state) => state);
};

export const useSymbolsWithKeys = getUseServiceWithSubscriptionKeys(symbolsService);

export { symbolsService };
